export enum Power {
  Austria = 1,
  England,
  France,
  Germany,
  Italy,
  Russia,
  Turkey
}
